
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new/books/sorting/visited/[pageNumber]",
      function () {
        return require("private-next-pages/new/books/sorting/visited/[pageNumber]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new/books/sorting/visited/[pageNumber]"])
      });
    }
  